import React from 'react';
import { useDroppable } from '@dnd-kit/core';

// ##### DropZone Component - Represents a column drop area
const DropZone = ({ 
  id, 
  column, 
  isActive, 
  children, 
  className = "" 
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`
        flex-1 min-h-[calc(100vh-200px)] rounded-lg transition-all duration-200
        ${isOver 
          ? 'bg-gray-50' 
          : 'bg-gray-100'
        }
        ${isActive 
          ? 'bg-blue-50' 
          : ''
        }
        ${className}
      `}
    >
      <div className="p-2 h-full flex flex-col">
        <div className="flex-1 flex flex-col space-y-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DropZone;
